import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Clock, Users, Flame, ChefHat, Heart, X, ShoppingBag, Filter, Star } from 'lucide-react';

const allRecipes = [
  // PETIT-DÉJEUNER
  {
    id: 1,
    name: 'Bol Complet Énergisant',
    emoji: '🥗',
    time: '20 min',
    servings: 2,
    calories: 450,
    protein: 18,
    category: 'Déjeuner',
    tags: ['Healthy', 'Protéiné'],
    goals: ['muscle-building', 'health', 'energy'],
    description: 'Un bowl coloré et nutritif pour faire le plein d\'énergie !',
    ingredients: ['200g de quinoa', '1 boîte de pois chiches', '1 avocat', '200g de légumes grillés', '2 c.à.s de sauce tahini', 'Jus de citron', 'Sel, poivre'],
    steps: ['Cuire le quinoa selon les instructions', 'Égoutter et faire revenir les pois chiches', 'Couper l\'avocat en tranches', 'Griller les légumes', 'Assembler le bowl', 'Arroser de sauce tahini'],
    vibe: '💪 Parfait après le sport !'
  },
  {
    id: 2,
    name: 'Smoothie Bowl Tropical',
    emoji: '🥣',
    time: '10 min',
    servings: 1,
    calories: 320,
    protein: 8,
    category: 'Petit-déj',
    tags: ['Vitaminé', 'Frais'],
    goals: ['weight-loss', 'health', 'energy'],
    description: 'Commencez votre journée avec une explosion de vitamines !',
    ingredients: ['1 mangue mûre', '1 banane congelée', '100ml de lait de coco', '30g de granola', 'Fruits frais', '1 c.à.s de graines de chia'],
    steps: ['Mixer la mangue et la banane', 'Ajouter le lait de coco', 'Verser dans un bol', 'Ajouter les toppings', 'Déguster immédiatement'],
    vibe: '🌅 Le petit-déj des champions !'
  },
  {
    id: 3,
    name: 'Wrap Poulet Avocat',
    emoji: '🌯',
    time: '15 min',
    servings: 2,
    calories: 380,
    protein: 28,
    category: 'Déjeuner',
    tags: ['Protéiné', 'Rapide'],
    goals: ['muscle-building', 'weight-loss'],
    description: 'Healthy, rapide et tellement bon !',
    ingredients: ['2 tortillas complètes', '200g de blanc de poulet', '1 avocat', 'Salade verte', '2 c.à.s de yaourt grec', 'Épices'],
    steps: ['Griller le poulet avec les épices', 'Écraser l\'avocat', 'Préparer la sauce yaourt', 'Étaler sur les tortillas', 'Rouler et couper'],
    vibe: '⚡ Lunch express parfait !'
  },
  {
    id: 4,
    name: 'Flocons Gourmands Chocolat',
    emoji: '🍫',
    time: '5 min + nuit',
    servings: 1,
    calories: 350,
    protein: 12,
    category: 'Petit-déj',
    tags: ['Gourmand', 'Meal prep'],
    goals: ['muscle-building', 'energy'],
    description: 'Prépare le soir, déguste le matin. Magie !',
    ingredients: ['50g de flocons d\'avoine', '150ml de lait d\'amande', '1 c.à.s de cacao', '1 banane', '1 c.à.s de beurre de cacahuète'],
    steps: ['Mélanger les flocons et le cacao', 'Ajouter le lait', 'Laisser au frigo toute la nuit', 'Ajouter les toppings le matin'],
    vibe: '😴 Préparé en 5 min hier soir !'
  },
  {
    id: 5,
    name: 'Salade César Légère',
    emoji: '🥬',
    time: '15 min',
    servings: 2,
    calories: 290,
    protein: 24,
    category: 'Déjeuner',
    tags: ['Light', 'Classique'],
    goals: ['weight-loss', 'health'],
    description: 'Le classique revisité en version équilibré !',
    ingredients: ['1 salade romaine', '150g de blanc de poulet', '30g de parmesan', '2 tranches de pain complet', 'Yaourt grec', 'Moutarde'],
    steps: ['Griller le poulet', 'Faire des croûtons', 'Préparer la sauce légère', 'Assembler la salade'],
    vibe: '🎯 Seulement 290 kcal !'
  },
  {
    id: 6,
    name: 'Bouchées Énergie Coco',
    emoji: '🥥',
    time: '15 min',
    servings: 12,
    calories: 85,
    protein: 3,
    category: 'Snack',
    tags: ['Sans cuisson', 'Sucré'],
    goals: ['energy', 'health'],
    description: 'Le snack parfait qui vous redonne de l\'énergie entre les repas !',
    ingredients: ['150g de dattes Medjool', '50g de noix de coco râpée', '50g d\'amandes', '1 c.à.s de cacao', '1 c.à.s de miel'],
    steps: ['Mixer les amandes', 'Ajouter les dattes', 'Former des boules', 'Rouler dans la noix de coco'],
    vibe: '🔋 Fringale ? Mange ça !'
  },
  {
    id: 7,
    name: 'Bol Mariné au Saumon',
    emoji: '🍣',
    time: '25 min',
    servings: 2,
    calories: 520,
    protein: 32,
    category: 'Dîner',
    tags: ['Oméga-3', 'Frais'],
    goals: ['muscle-building', 'health'],
    description: 'Un voyage culinaire équilibré à Hawaï !',
    ingredients: ['200g de riz à sushi', '200g de saumon frais', '100g d\'edamame', '1 mangue', 'Sauce soja', 'Huile de sésame'],
    steps: ['Cuire le riz', 'Couper le saumon en cubes', 'Mariner dans la sauce soja', 'Assembler le bowl'],
    vibe: '🏝️ Comme en vacances !'
  },
  {
    id: 8,
    name: 'Pancakes Protéinés',
    emoji: '🥞',
    time: '20 min',
    servings: 2,
    calories: 380,
    protein: 25,
    category: 'Petit-déj',
    tags: ['Protéiné', 'Gourmand'],
    goals: ['muscle-building'],
    description: 'Gourmandise + protéines = le combo parfait !',
    ingredients: ['60g de farine d\'avoine', '1 scoop de whey vanille', '2 œufs', '1 banane', '100g de myrtilles'],
    steps: ['Mixer tous les ingrédients', 'Faire chauffer la poêle', 'Verser des louches de pâte', 'Retourner quand des bulles apparaissent'],
    vibe: '🏋️ 25g de protéines !'
  },
  {
    id: 9,
    name: 'Soupe Détox Légumes',
    emoji: '🥣',
    time: '30 min',
    servings: 4,
    calories: 120,
    protein: 4,
    category: 'Dîner',
    tags: ['Détox', 'Light'],
    goals: ['weight-loss', 'health'],
    description: 'Idéale pour un dîner léger et réconfortant',
    ingredients: ['2 courgettes', '2 carottes', '1 poireau', '1 oignon', 'Bouillon de légumes', 'Herbes fraîches'],
    steps: ['Couper tous les légumes', 'Faire revenir l\'oignon', 'Ajouter les légumes et le bouillon', 'Mixer'],
    vibe: '🌿 Reset votre corps !'
  },
  {
    id: 10,
    name: 'Omelette Champignons',
    emoji: '🍳',
    time: '10 min',
    servings: 1,
    calories: 280,
    protein: 22,
    category: 'Petit-déj',
    tags: ['Protéiné', 'Rapide'],
    goals: ['weight-loss', 'muscle-building'],
    description: 'Classique mais efficace pour bien démarrer',
    ingredients: ['3 œufs', '100g de champignons', '30g de fromage râpé', 'Persil', 'Sel, poivre'],
    steps: ['Battre les œufs', 'Faire sauter les champignons', 'Verser les œufs', 'Plier et servir'],
    vibe: '💪 22g de protéines !'
  },
  {
    id: 11,
    name: 'Bowl Quinoa Légumes',
    emoji: '🥙',
    time: '25 min',
    servings: 2,
    calories: 420,
    protein: 15,
    category: 'Déjeuner',
    tags: ['Veggie', 'Complet'],
    goals: ['health', 'weight-loss'],
    description: 'Un repas végétarien complet et savoureux',
    ingredients: ['150g de quinoa', '1 patate douce', '100g de pois chiches', 'Épinards', 'Houmous', 'Graines de courge'],
    steps: ['Cuire le quinoa', 'Rôtir la patate douce', 'Assembler avec les légumes', 'Ajouter le houmous'],
    vibe: '🌱 100% végétarien !'
  },
  {
    id: 12,
    name: 'Tartines Avocat Œuf',
    emoji: '🥑',
    time: '10 min',
    servings: 1,
    calories: 350,
    protein: 14,
    category: 'Petit-déj',
    tags: ['Tendance', 'Healthy'],
    goals: ['health', 'energy'],
    description: 'Le brunch équilibré par excellence',
    ingredients: ['2 tranches de pain complet', '1 avocat', '2 œufs', 'Graines de sésame', 'Piment d\'Espelette'],
    steps: ['Toaster le pain', 'Écraser l\'avocat', 'Pocher les œufs', 'Assembler et assaisonner'],
    vibe: '📸 Instagrammable !'
  },
  {
    id: 13,
    name: 'Smoothie Vert Détox',
    emoji: '🥬',
    time: '5 min',
    servings: 1,
    calories: 180,
    protein: 5,
    category: 'Petit-déj',
    tags: ['Détox', 'Vitaminé'],
    goals: ['weight-loss', 'health'],
    description: 'Un boost de vitamines pour votre corps',
    ingredients: ['1 poignée d\'épinards', '1 banane', '1 pomme', 'Jus de citron', 'Gingembre frais', '200ml d\'eau'],
    steps: ['Mettre tous les ingrédients dans le blender', 'Mixer jusqu\'à obtenir une texture lisse', 'Servir frais'],
    vibe: '💚 Detox en 5 min !'
  },
  {
    id: 14,
    name: 'Poulet Grillé Légumes',
    emoji: '🍗',
    time: '35 min',
    servings: 2,
    calories: 420,
    protein: 38,
    category: 'Dîner',
    tags: ['Protéiné', 'Simple'],
    goals: ['muscle-building', 'weight-loss'],
    description: 'La base d\'un repas muscu réussi',
    ingredients: ['2 filets de poulet', 'Courgettes', 'Poivrons', 'Huile d\'olive', 'Herbes de Provence', 'Ail'],
    steps: ['Mariner le poulet', 'Couper les légumes', 'Griller le tout', 'Servir chaud'],
    vibe: '💪 38g de protéines !'
  },
  {
    id: 15,
    name: 'Riz Sauté Crevettes',
    emoji: '🦐',
    time: '20 min',
    servings: 2,
    calories: 480,
    protein: 28,
    category: 'Dîner',
    tags: ['Asiatique', 'Rapide'],
    goals: ['muscle-building', 'energy'],
    description: 'Un classique asiatique équilibré',
    ingredients: ['200g de riz basmati', '200g de crevettes', '2 œufs', 'Petits pois', 'Sauce soja', 'Oignon vert'],
    steps: ['Cuire le riz à l\'avance', 'Faire sauter les crevettes', 'Ajouter les œufs brouillés', 'Mélanger avec le riz'],
    vibe: '🥢 Meilleur qu\'au resto !'
  },
  {
    id: 16,
    name: 'Tacos Fitness',
    emoji: '🌮',
    time: '20 min',
    servings: 2,
    calories: 390,
    protein: 26,
    category: 'Dîner',
    tags: ['Fun', 'Protéiné'],
    goals: ['muscle-building', 'maintenance'],
    description: 'Des tacos équilibré et gourmands',
    ingredients: ['4 tortillas de maïs', '200g de bœuf haché 5%', 'Tomates', 'Oignon', 'Avocat', 'Coriandre'],
    steps: ['Cuire la viande avec les épices', 'Préparer les garnitures', 'Chauffer les tortillas', 'Assembler et déguster'],
    vibe: '🎉 Soirée tacos gourmande !'
  },
  {
    id: 17,
    name: 'Porridge Pomme Cannelle',
    emoji: '🍎',
    time: '10 min',
    servings: 1,
    calories: 320,
    protein: 10,
    category: 'Petit-déj',
    tags: ['Réconfortant', 'Healthy'],
    goals: ['health', 'energy', 'weight-loss'],
    description: 'Comme un câlin au petit-déjeuner',
    ingredients: ['50g de flocons d\'avoine', '200ml de lait', '1 pomme', 'Cannelle', 'Miel', 'Noix'],
    steps: ['Cuire les flocons dans le lait', 'Ajouter la pomme râpée', 'Saupoudrer de cannelle', 'Garnir de noix'],
    vibe: '🍂 Parfait en automne !'
  },
  {
    id: 18,
    name: 'Salade Thon Haricots',
    emoji: '🥗',
    time: '10 min',
    servings: 2,
    calories: 310,
    protein: 28,
    category: 'Déjeuner',
    tags: ['Protéiné', 'Rapide'],
    goals: ['weight-loss', 'muscle-building'],
    description: 'Simple, rapide et pleine de protéines',
    ingredients: ['2 boîtes de thon', '400g de haricots verts', 'Tomates cerises', 'Olives', 'Vinaigrette légère'],
    steps: ['Cuire les haricots', 'Égoutter le thon', 'Couper les tomates', 'Mélanger le tout'],
    vibe: '⏱️ Prêt en 10 min !'
  },
  {
    id: 19,
    name: 'Curry de Lentilles',
    emoji: '🍛',
    time: '30 min',
    servings: 4,
    calories: 380,
    protein: 18,
    category: 'Dîner',
    tags: ['Veggie', 'Épicé'],
    goals: ['health', 'muscle-building'],
    description: 'Un curry végétarien plein de saveurs',
    ingredients: ['300g de lentilles corail', 'Lait de coco', 'Pâte de curry', 'Tomates', 'Épinards', 'Riz basmati'],
    steps: ['Cuire les lentilles', 'Ajouter le curry et le lait de coco', 'Incorporer les épinards', 'Servir avec du riz'],
    vibe: '🔥 Épicé mais pas trop !'
  },
  {
    id: 20,
    name: 'Gaufres Protéinées',
    emoji: '🧇',
    time: '15 min',
    servings: 2,
    calories: 340,
    protein: 22,
    category: 'Petit-déj',
    tags: ['Gourmand', 'Protéiné'],
    goals: ['muscle-building'],
    description: 'Des gaufres qui font du bien aux muscles',
    ingredients: ['80g de farine d\'avoine', '1 scoop de whey', '2 œufs', '100ml de lait', 'Fruits rouges'],
    steps: ['Mélanger les ingrédients secs', 'Ajouter les œufs et le lait', 'Cuire dans le gaufrier', 'Garnir de fruits'],
    vibe: '🏆 Petit-déj de champion !'
  },
  {
    id: 21,
    name: 'Steak Haché Purée',
    emoji: '🥩',
    time: '25 min',
    servings: 2,
    calories: 520,
    protein: 35,
    category: 'Dîner',
    tags: ['Classique', 'Protéiné'],
    goals: ['muscle-building', 'maintenance'],
    description: 'Le classique français version équilibré',
    ingredients: ['2 steaks hachés 5%', '400g de pommes de terre', 'Lait écrémé', 'Muscade', 'Persil'],
    steps: ['Cuire les pommes de terre', 'Écraser en purée avec le lait', 'Griller les steaks', 'Servir ensemble'],
    vibe: '🇫🇷 Comfort food !'
  },
  {
    id: 22,
    name: 'Bowl Açaí',
    emoji: '🫐',
    time: '10 min',
    servings: 1,
    calories: 380,
    protein: 8,
    category: 'Petit-déj',
    tags: ['Tendance', 'Antioxydant'],
    goals: ['health', 'energy'],
    description: 'Le super-aliment brésilien tendance',
    ingredients: ['100g de pulpe d\'açaí', '1 banane', 'Granola', 'Fruits frais', 'Noix de coco', 'Miel'],
    steps: ['Mixer l\'açaí avec la banane', 'Verser dans un bol', 'Ajouter les toppings', 'Déguster immédiatement'],
    vibe: '🌴 Vibes brésiliennes !'
  },
  {
    id: 23,
    name: 'Spaghetti Bolognaise Light',
    emoji: '🍝',
    time: '35 min',
    servings: 4,
    calories: 450,
    protein: 28,
    category: 'Dîner',
    tags: ['Italien', 'Familial'],
    goals: ['muscle-building', 'maintenance'],
    description: 'La bolo version allégée mais délicieuse',
    ingredients: ['300g de spaghetti complets', '400g de bœuf haché 5%', 'Sauce tomate', 'Oignon', 'Carottes', 'Parmesan'],
    steps: ['Faire revenir la viande', 'Ajouter les légumes et la sauce', 'Cuire les pâtes', 'Mélanger et servir'],
    vibe: '👨‍👩‍👧‍👦 Toute la famille adore !'
  },
  {
    id: 24,
    name: 'Crêpes Sarrasin',
    emoji: '🥞',
    time: '20 min',
    servings: 4,
    calories: 180,
    protein: 8,
    category: 'Déjeuner',
    tags: ['Breton', 'Sans gluten'],
    goals: ['health', 'weight-loss'],
    description: 'Des galettes bretonnes authentiques',
    ingredients: ['200g de farine de sarrasin', '1 œuf', '400ml d\'eau', 'Sel', 'Jambon', 'Fromage', 'Œuf'],
    steps: ['Préparer la pâte', 'Laisser reposer', 'Cuire les galettes', 'Garnir au choix'],
    vibe: '🇫🇷 Vive la Bretagne !'
  },
  {
    id: 25,
    name: 'Chia Pudding Fruits',
    emoji: '🫐',
    time: '5 min + 4h',
    servings: 2,
    calories: 280,
    protein: 10,
    category: 'Petit-déj',
    tags: ['Meal prep', 'Healthy'],
    goals: ['weight-loss', 'health'],
    description: 'Prépare la veille pour un matin facile',
    ingredients: ['4 c.à.s de graines de chia', '300ml de lait d\'amande', 'Vanille', 'Fruits de saison', 'Miel'],
    steps: ['Mélanger le chia et le lait', 'Ajouter la vanille', 'Réfrigérer 4h minimum', 'Garnir de fruits'],
    vibe: '⏰ Meal prep parfait !'
  },
  {
    id: 26,
    name: 'Blanc de Poulet Mariné',
    emoji: '🍗',
    time: '30 min + marinade',
    servings: 4,
    calories: 220,
    protein: 42,
    category: 'Dîner',
    tags: ['Protéiné', 'Meal prep'],
    goals: ['muscle-building', 'weight-loss'],
    description: 'La base parfaite pour vos préparations de la semaine',
    ingredients: ['4 blancs de poulet', 'Citron', 'Ail', 'Herbes', 'Huile d\'olive', 'Paprika'],
    steps: ['Préparer la marinade', 'Mariner 2h minimum', 'Griller au four ou à la poêle', 'Trancher et servir'],
    vibe: '📦 Meal prep king !'
  },
  {
    id: 27,
    name: 'Houmous Maison',
    emoji: '🧆',
    time: '10 min',
    servings: 6,
    calories: 150,
    protein: 6,
    category: 'Snack',
    tags: ['Veggie', 'Dip'],
    goals: ['health', 'maintenance'],
    description: 'Bien meilleur que celui du supermarché',
    ingredients: ['400g de pois chiches', '2 c.à.s de tahini', 'Jus de citron', 'Ail', 'Huile d\'olive', 'Cumin'],
    steps: ['Mixer les pois chiches', 'Ajouter le tahini et le citron', 'Assaisonner', 'Servir avec des crudités'],
    vibe: '🥕 Parfait avec des crudités !'
  },
  {
    id: 28,
    name: 'Shakshuka',
    emoji: '🍳',
    time: '25 min',
    servings: 2,
    calories: 320,
    protein: 18,
    category: 'Petit-déj',
    tags: ['Oriental', 'Protéiné'],
    goals: ['weight-loss', 'health'],
    description: 'Un petit-déj qui change de l\'ordinaire',
    ingredients: ['4 œufs', '400g de tomates concassées', 'Poivrons', 'Oignon', 'Cumin', 'Paprika', 'Feta'],
    steps: ['Faire revenir les légumes', 'Ajouter les tomates et épices', 'Créer des puits pour les œufs', 'Cuire jusqu\'à ce que les œufs soient pris'],
    vibe: '☀️ Voyage au Moyen-Orient !'
  },
  {
    id: 29,
    name: 'Barres Granola Maison',
    emoji: '🍫',
    time: '30 min',
    servings: 12,
    calories: 180,
    protein: 6,
    category: 'Snack',
    tags: ['Meal prep', 'Énergie'],
    goals: ['energy', 'maintenance'],
    description: 'Vos encas sains pour la semaine',
    ingredients: ['200g de flocons d\'avoine', '100g de miel', '50g de beurre de cacahuète', 'Pépites de chocolat', 'Amandes', 'Raisins secs'],
    steps: ['Mélanger tous les ingrédients', 'Étaler dans un moule', 'Cuire 20 min à 180°C', 'Couper en barres'],
    vibe: '📦 Snacks de la semaine !'
  },
  {
    id: 30,
    name: 'Pavé de Saumon Asperges',
    emoji: '🐟',
    time: '25 min',
    servings: 2,
    calories: 450,
    protein: 36,
    category: 'Dîner',
    tags: ['Oméga-3', 'Élégant'],
    goals: ['muscle-building', 'health'],
    description: 'Un dîner chic et équilibré',
    ingredients: ['2 pavés de saumon', '1 botte d\'asperges', 'Citron', 'Aneth', 'Huile d\'olive', 'Ail'],
    steps: ['Préparer les asperges', 'Assaisonner le saumon', 'Cuire au four 15 min', 'Servir avec un filet de citron'],
    vibe: '✨ Dîner en amoureux !'
  },
  {
    id: 31,
    name: 'Yaourt Grec Toppings',
    emoji: '🥛',
    time: '5 min',
    servings: 1,
    calories: 250,
    protein: 20,
    category: 'Snack',
    tags: ['Protéiné', 'Rapide'],
    goals: ['muscle-building', 'weight-loss'],
    description: 'Le snack protéiné ultra rapide',
    ingredients: ['200g de yaourt grec 0%', 'Granola', 'Fruits rouges', 'Miel', 'Graines de lin'],
    steps: ['Verser le yaourt dans un bol', 'Ajouter les toppings', 'Déguster'],
    vibe: '⚡ Snack express !'
  },
  {
    id: 32,
    name: 'Wok de Légumes Tofu',
    emoji: '🥡',
    time: '20 min',
    servings: 2,
    calories: 350,
    protein: 22,
    category: 'Dîner',
    tags: ['Veggie', 'Asiatique'],
    goals: ['weight-loss', 'health'],
    description: 'Un wok végétarien savoureux',
    ingredients: ['200g de tofu ferme', 'Brocoli', 'Carottes', 'Poivrons', 'Sauce soja', 'Gingembre', 'Sésame'],
    steps: ['Presser et couper le tofu', 'Faire sauter le tofu', 'Ajouter les légumes', 'Assaisonner et servir'],
    vibe: '🌿 100% veggie !'
  }
];

const categories = ['Tous', 'Petit-déj', 'Déjeuner', 'Dîner', 'Snack', '❤️ Favoris'];

const goalLabels = {
  'weight-loss': { label: 'Perte de poids', emoji: '🔥' },
  'muscle-building': { label: 'Prise de muscle', emoji: '💪' },
  'health': { label: 'Santé', emoji: '🌱' },
  'energy': { label: 'Énergie', emoji: '⚡' },
  'maintenance': { label: 'Maintien', emoji: '⚖️' }
};

const RecipeModal = ({ recipe, onClose, isFavorite, onToggleFavorite }) => {
  if (!recipe) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="recipe-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="recipe-modal-header">
          <span className="recipe-modal-emoji">{recipe.emoji}</span>
          <h2>{recipe.name}</h2>
          <p>{recipe.description}</p>
          <div className="recipe-modal-vibe">{recipe.vibe}</div>
          <button 
            className={`modal-favorite-btn ${isFavorite ? 'active' : ''}`}
            onClick={() => onToggleFavorite(recipe.id)}
          >
            <Heart size={20} fill={isFavorite ? 'currentColor' : 'none'} />
            {isFavorite ? 'Dans vos favoris' : 'Ajouter aux favoris'}
          </button>
        </div>

        <div className="recipe-modal-meta">
          <div className="meta-item">
            <Clock size={18} />
            <span>{recipe.time}</span>
          </div>
          <div className="meta-item">
            <Users size={18} />
            <span>{recipe.servings} pers.</span>
          </div>
          <div className="meta-item">
            <Flame size={18} />
            <span>{recipe.calories} kcal</span>
          </div>
          <div className="meta-item">
            <Star size={18} />
            <span>{recipe.protein}g prot.</span>
          </div>
        </div>

        <div className="recipe-modal-content">
          <div className="recipe-section">
            <h3><ShoppingBag size={18} /> Ingrédients</h3>
            <ul className="ingredients-list">
              {recipe.ingredients.map((ing, i) => (
                <li key={i}>{ing}</li>
              ))}
            </ul>
          </div>

          <div className="recipe-section">
            <h3><ChefHat size={18} /> Préparation</h3>
            <ol className="steps-list">
              {recipe.steps.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
          </div>
        </div>

        <div className="recipe-modal-tags">
          {recipe.tags.map(tag => (
            <span key={tag} className="recipe-tag">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

const RecipesPage = () => {
  const { profile, user } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [favorites, setFavorites] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [showGoalFilter, setShowGoalFilter] = useState(true);

  // Charger les favoris depuis localStorage
  useEffect(() => {
    const savedFavorites = localStorage.getItem(`nutribot_favorites_${user?.id || 'guest'}`);
    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }
  }, [user]);

  // Sauvegarder les favoris
  useEffect(() => {
    localStorage.setItem(`nutribot_favorites_${user?.id || 'guest'}`, JSON.stringify(favorites));
  }, [favorites, user]);

  const toggleFavorite = (e, id) => {
    if (e) e.stopPropagation();
    setFavorites(prev => 
      prev.includes(id) ? prev.filter(f => f !== id) : [...prev, id]
    );
  };

  // Filtrer les recettes selon le profil et la catégorie
  const getFilteredRecipes = () => {
    let recipes = allRecipes;

    // Filtrer par favoris
    if (selectedCategory === '❤️ Favoris') {
      return recipes.filter(r => favorites.includes(r.id));
    }

    // Filtrer par catégorie
    if (selectedCategory !== 'Tous') {
      recipes = recipes.filter(r => r.category === selectedCategory);
    }

    // Filtrer par objectif du profil si activé
    if (showGoalFilter && profile?.goal) {
      const priorityRecipes = recipes.filter(r => r.goals.includes(profile.goal));
      const otherRecipes = recipes.filter(r => !r.goals.includes(profile.goal));
      recipes = [...priorityRecipes, ...otherRecipes];
    }

    return recipes;
  };

  const filteredRecipes = getFilteredRecipes();
  const userName = profile?.name || 'toi';
  const userGoal = profile?.goal ? goalLabels[profile.goal] : null;

  return (
    <div className="recipes-page">
      <div className="page-header">
        <div className="header-content">
          <h1>🍽️ Recettes adaptées à {userName}</h1>
          <p>
            {userGoal 
              ? `${userGoal.emoji} Recettes optimisées pour votre objectif : ${userGoal.label}`
              : 'Des recettes simples, délicieuses et bonnes pour vous !'
            }
          </p>
          {profile?.goal && (
            <button 
              className={`goal-filter-btn ${showGoalFilter ? 'active' : ''}`}
              onClick={() => setShowGoalFilter(!showGoalFilter)}
            >
              <Filter size={16} />
              {showGoalFilter ? 'Voir toutes les recettes' : 'Filtrer pour mon objectif'}
            </button>
          )}
        </div>
      </div>

      <div className="category-tabs">
        {categories.map(cat => (
          <button
            key={cat}
            className={`category-tab ${selectedCategory === cat ? 'active' : ''} ${cat === '❤️ Favoris' && favorites.length > 0 ? 'has-items' : ''}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
            {cat === '❤️ Favoris' && favorites.length > 0 && (
              <span className="favorites-count">{favorites.length}</span>
            )}
          </button>
        ))}
      </div>

      {selectedCategory === '❤️ Favoris' && favorites.length === 0 ? (
        <div className="empty-favorites">
          <Heart size={48} />
          <h3>Pas encore de favoris</h3>
          <p>Clique sur le ❤️ d'une recette pour l'ajouter ici !</p>
        </div>
      ) : (
        <div className="recipes-grid">
          {filteredRecipes.map((recipe, i) => {
            const isRecommended = showGoalFilter && profile?.goal && recipe.goals.includes(profile.goal);
            return (
              <div 
                key={recipe.id} 
                className={`recipe-card ${isRecommended ? 'recommended' : ''}`}
                style={{ animationDelay: `${i * 0.03}s` }}
                onClick={() => setSelectedRecipe(recipe)}
              >
                {isRecommended && (
                  <div className="recommended-badge">
                    {goalLabels[profile.goal]?.emoji} Pour toi
                  </div>
                )}
                <div className="recipe-header">
                  <span className="recipe-emoji">{recipe.emoji}</span>
                  <button 
                    className={`favorite-btn ${favorites.includes(recipe.id) ? 'active' : ''}`}
                    onClick={(e) => toggleFavorite(e, recipe.id)}
                  >
                    <Heart size={18} fill={favorites.includes(recipe.id) ? 'currentColor' : 'none'} />
                  </button>
                </div>

                <h3 className="recipe-name">{recipe.name}</h3>
                <p className="recipe-desc">{recipe.description}</p>

                <div className="recipe-vibe">{recipe.vibe}</div>

                <div className="recipe-tags">
                  {recipe.tags.map(tag => (
                    <span key={tag} className="recipe-tag">{tag}</span>
                  ))}
                </div>

                <div className="recipe-meta">
                  <span><Clock size={14} /> {recipe.time}</span>
                  <span><Flame size={14} /> {recipe.calories} kcal</span>
                  <span><Star size={14} /> {recipe.protein}g</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedRecipe && (
        <RecipeModal 
          recipe={selectedRecipe} 
          onClose={() => setSelectedRecipe(null)}
          isFavorite={favorites.includes(selectedRecipe.id)}
          onToggleFavorite={(id) => toggleFavorite(null, id)}
        />
      )}
    </div>
  );
};

export default RecipesPage;
